import React from "react";

export default function Footer (props) {
  return(
    <footer className="h-fit pb-2 flex justify-center items-center text-light-50 dark:text-dark-50">
      <small>© {new Date().getFullYear()} Patrick Stark</small>
    </footer>
  );
}
